// @flow
import React, { PureComponent } from 'react';
import { StyleSheet } from 'react-native';
import FullButton from './FullButton';
import theme from '../../../theme-config';

class SecondaryFullButton extends PureComponent<Props> {
  render() {
    const styles = getStyles();
    const { style, ...others } = this.props;
    return (
      <FullButton
        {...others}
        style={[styles.container, styles.secondaryButtonColors, style]}
        textStyle={[styles.text, this.props.textStyle]}
      />
    );
  }
}

type Props = {
  text: string,
  style?: any,
  disabled?: boolean,
  isLoading?: boolean,
  emphasizeSubText?: boolean,
  textStyle?: any,
  onPress?: ?Function,
  onLongPress?: ?Function,
  testID?: string,
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      height: 37,
      alignItems: 'center',
      justifyContent: 'center',
    },
    text: {
      fontSize: 16,
      color: theme.buttons.SECONDARY.textColor,
    },
    secondaryButtonColors: {
      backgroundColor: theme.buttons.SECONDARY.backgroundColor,
      borderColor: theme.buttons.SECONDARY.borderColor,
      borderWidth: 2,
    },
  });

export default SecondaryFullButton;
